import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import {
  DxTreeViewTypes,
  DxTreeViewComponent,
} from 'devextreme-angular/ui/tree-view';
import { navigation } from '../../app-navigation';
import { DomSanitizer } from '@angular/platform-browser';
import { OrganisationUnitModel } from 'src/app/models/organisation-unit/organisation-unit.model';
import { TenantTypeModel } from 'src/app/models/tenants/tenant-type.model';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  standalone: false
})
export class SideNavComponent implements AfterViewInit {
  @ViewChild(DxTreeViewComponent, { static: true }) menu!: DxTreeViewComponent;

  @Output()
  selectedItemChanged = new EventEmitter<DxTreeViewTypes.ItemClickEvent>();

  @Output()
  openMenu = new EventEmitter<any>();

  @Input()
  set selectedItem(value: String) {
    this.selectedItemValue = value;
    this.setSelectedItem();
  }

  @Input()
  userRole!: string;

  @Input()
  tenantType!: TenantTypeModel;

  @Input()
  showLearningPath!: boolean;

  @Input()
  showComplianceCategory!: boolean;

  @Input()
  userLocation: OrganisationUnitModel | null = null;

  get selectedItem(): String {
    return this.selectedItemValue;
  }

  selectedItemValue: String = '';
  items!: any[];

  constructor(
    private sanitized: DomSanitizer
  ) {
    this.items = navigation;
  }


  ngAfterViewInit(): void {
    // Brokers in Broker Pool tenants are treated as Employees
    const effectiveRole =
      this.userRole === 'Broker' && this.tenantType == TenantTypeModel.BrokerPool
        ? 'Employee'
        : this.userRole;

    if (effectiveRole == 'SuperAdmin' && this.userLocation?.parentId) {
      this.items = navigation.filter((item) => {
        if (item.items) {
          item.items = item.items.filter((subItem: any) => {
            return subItem.text !== 'SIDENAV.GENERAL';
          });
        }

        return true;
      });
    } else if (effectiveRole == 'Manager') {
      this.items = navigation.filter((item) => {
        if (item.items) {
          item.items = item.items.filter((subItem: any) => {
            return (
              subItem.text !== 'SIDENAV.MANAGE-TRAININGS' &&
              subItem.text !== 'SIDENAV.MANAGE-ELEARNING' &&
              subItem.text !== 'SIDENAV.ADMINISTRATION' &&
              subItem.text !== 'SIDENAV.REGISTRATION-LINKS' &&
              subItem.text !== 'SIDENAV.MANAGE-LEARNING-PATH'
            );
          });
        }

        return item.text !== 'SIDENAV.SETTINGS';
      });
    } else if (effectiveRole == 'Employee') {
      this.items = navigation.filter((item) => {
        if (item.items) {
          item.items = item.items.filter((subItem: any) => {
            return (
              subItem.text !== 'SIDENAV.MANAGE-TRAININGS' &&
              subItem.text !== 'SIDENAV.MANAGE-ELEARNING' &&
              subItem.text !== 'SIDENAV.ADMINISTRATION' &&
              subItem.text !== 'SIDENAV.MANAGE-LEARNING-PATH'
            );
          });
        }

        return (
          item.text !== 'SIDENAV.ORGANIZATION' &&
          item.text !== 'SIDENAV.SETTINGS'
        );
      });

      this.expandAllItems(this.items);
    } else if (effectiveRole == 'Broker') {
      this.items = navigation.filter((item) => {
        if (item.items) {
          item.items = item.items.filter((subItem: any) => {
            return (
              subItem.text !== 'SIDENAV.MANAGE-TRAININGS' &&
              subItem.text !== 'SIDENAV.MANAGE-ELEARNING' &&
              subItem.text !== 'SIDENAV.ADMINISTRATION' &&
              subItem.text !== 'SIDENAV.INTEGRATIONS' &&
              subItem.text !== 'SIDENAV.REGISTRATION-LINKS' &&
              subItem.text !== 'SIDENAV.STRUCTURE' &&
              subItem.text !== 'SIDENAV.MANAGE-LEARNING-PATH'&&
              subItem.text !== 'SIDENAV.GENERAL' &&
              subItem.text !== 'SIDENAV.ACTIVITY-LOG'
            );
          });
        }

        return true;
      });
    } else if (effectiveRole == 'Trainer') {
      this.items = navigation.filter((item) => {
        if (item.items) {
          item.items = item.items.filter((subItem: any) => {
            return (
              subItem.text !== 'SIDENAV.MANAGE-ELEARNING' &&
              subItem.text !== 'SIDENAV.ADMINISTRATION' &&
              subItem.text !== 'SIDENAV.STRUCTURE' &&
              subItem.text !== 'SIDENAV.EMPLOYEES' &&
              subItem.text !== 'SIDENAV.MANAGE-LEARNING-PATH'
            );
          });
        }

        return (
          item.text !== 'SIDENAV.ORGANIZATION' &&
          item.text !== 'SIDENAV.SETTINGS'
        );
      });
    }

    if (!this.showLearningPath) {
      this.items.forEach((item) => {
        if (item.items) {
          item.items = item.items.filter(
            (subItem: any) => subItem.text !== 'SIDENAV.LEARNING-PATHS'
          );
        }
      });
    }

    if (effectiveRole !== 'SuperAdmin' && !this.showComplianceCategory) {
      this.items = this.items.filter((item) => {
        if (item.items) {
          item.items = item.items.filter(
            (subItem: any) =>
              subItem.text !== 'SIDENAV.MANAGE-COMPLIANCE'
          );

          if (item.items.length === 0) {
            return false;
          }
        }

        return true;
      });
    }

    this.items = [...this.items];

    this.setSelectedItem();
  }


  expandCurrentMenuItem(currentRoute: String) {
    this.menu.instance.selectItem(currentRoute);

    this.items.forEach((item) => {
      if (item.items) {
        item.items!.forEach((nestedItem: any) => {
          if (nestedItem.path === currentRoute) {
            this.menu.instance.expandItem(currentRoute);
          }
        });
      }
    });
  }

  getTrustedSvg(svg: string) {
    return this.sanitized.bypassSecurityTrustHtml(svg);
  }

  setSelectedItem() {
    if (!this.menu.instance) {
      return;
    }

    this.menu.instance.selectItem(this.selectedItemValue);
    this.expandCurrentMenuItem(this.selectedItemValue);

    if (this.selectedItemValue === '/profile') {
      this.menu.instance.unselectAll();
    }
  }

  onItemClick(event: DxTreeViewTypes.ItemClickEvent) {
    this.selectedItemChanged.emit(event);
  }

  private expandAllItems(items: any[]) {
    items.forEach(item => {
      item.expanded = true;
      if (item.items && item.items.length) {
        this.expandAllItems(item.items);
      }
    });
  }
}
